import type React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AssignmentForm from "./AssignmentForm";
import { AssignmentData, Venue } from "../types/site-visit";
import VenueCard from "./VenueCard";

interface AssignSiteVisitModalProps {
  open: boolean;
  venue: Venue | null;
  onClose: () => void;
  onAssign: (siteVisitId: number, data: AssignmentData) => Promise<void>;

  loading?: boolean;
}

const AssignSiteVisitModal: React.FC<AssignSiteVisitModalProps> = ({
  open,
  venue,
  onClose,
  onAssign,
  loading = false,
}) => {
  const handleAssign = async (data: AssignmentData) => {
    if (venue) {
      await onAssign(venue.id, data);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
        }}
      >
        <Box component="span" sx={{ fontSize: "1.25rem", fontWeight: "bold" }}>
          Assign Site Visit
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 0 }}>
        {venue && (
          <Box>
            <VenueCard venue={venue} />
            <AssignmentForm
              onSubmit={handleAssign}
              onCancel={onClose}
              loading={loading}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AssignSiteVisitModal;
